import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReviewerNavbar from '../components/ReviewerNavbar';
import { useReviewerAuth, ReviewerAPI } from '../context/ReviewerAuthContext';
import LoadingState from '../components/LoadingState';
import { ShieldCheck, CheckCircle } from 'lucide-react';

// Lets a reviewer re-read the confidentiality agreement anytime, and see
// exactly which version they accepted and when — unlike ReviewerNdaGate,
// this never blocks access or asks for re-acceptance.
export default function ReviewerAgreementView() {
  const { reviewer } = useReviewerAuth();
  const navigate = useNavigate();
  const [agreement, setAgreement] = useState(null);

  useEffect(() => {
    ReviewerAPI.get('/api/reviewer/nda').then(r => setAgreement(r.data)).catch(() => {});
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <ReviewerNavbar />
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '36px 24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
          <ShieldCheck size={20} color="var(--pink)" />
          <h1 style={{ fontWeight: 900, fontSize: 22, color: 'var(--text)', letterSpacing: '-0.01em' }}>Confidentiality Agreement</h1>
        </div>

        {reviewer?.nda_accepted_at && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(0,200,150,0.06)', border: '1.5px solid rgba(0,200,150,0.2)', borderRadius: 'var(--r-md)', padding: '11px 14px', margin: '16px 0' }}>
            <CheckCircle size={14} color="var(--green)" />
            <span style={{ fontSize: 12.5, color: 'var(--green)', fontWeight: 600 }}>
              You accepted version {reviewer.nda_agreement_version} on {new Date(reviewer.nda_accepted_at).toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}.
            </span>
          </div>
        )}

        {!agreement ? (
          <LoadingState label="Loading agreement…" minHeight={160} />
        ) : (
          <div className="card" style={{ padding: '20px 24px', fontSize: 13, lineHeight: 1.75, color: 'var(--text-secondary)', whiteSpace: 'pre-wrap', fontWeight: 400 }}>
            {agreement.text}
          </div>
        )}

        <button onClick={() => navigate('/reviewer/dashboard')} className="btn-ghost" style={{ marginTop: 18 }}>Back to My Queue</button>
      </div>
    </div>
  );
}
